import {Component, inject, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Product} from '../../Model/Catalog/Product';
import {ViewService} from '../../Services/view.service';
import {TranslationService} from '../../Services/translation.service';
import {ProductState} from '../../Model/Catalog/ProductState';
import {custom} from 'devextreme/ui/dialog';
import {TranslateService} from '@ngx-translate/core';
import {UserManagementService} from '../../Services/userManagment.service';
import {ValidationService} from '../../Services/Validation/validation.service';
import {LoginService} from '../../Services/login.service';
import {ProductService} from '../../Services/CatalogManagement/product.service';
import {CatalogService} from '../../Services/CatalogManagement/catalog.service';
import {ProductStateService} from '../../Services/productState.service';
import {SupplierPidMappingService} from '../../Services/supplierPidMapping.service';
import {SystemService} from '../../Services/system.service';
import {ProductDataSource} from "../../Model/dataProcess/productDataSource";
import {DataSourcesService} from "../../Services/DataProcess/datasources.service";
import {CustomItemCreatingEvent} from 'devextreme/ui/select_box';
import {Address} from "../../Model/Catalog/Address";
import {lastValueFrom} from "rxjs";
import {NpInputControlContext} from "../../ui/inputControl/np-input-control-context";

@Component({
    selector: 'infos',
    templateUrl: 'infos.html',
    styleUrls: ['infos.css', 'template.css'],
    standalone: false
})
export class Infos implements OnChanges, OnInit {
    context = inject(NpInputControlContext);

    selectedTranslateLanguage: string = 'deu';
    edeNumbersDummy: string[] = new Array();

    constructor(
        public translate: TranslateService,
        public userManagement: UserManagementService,
        public validationService: ValidationService,
        public productSercvice: ProductService,
        public loginService: LoginService,
        public catalogService: CatalogService,
        public productStateService: ProductStateService,
        public supplierPidMappingService: SupplierPidMappingService,
        public systemService: SystemService,
        public dataSourceService: DataSourcesService
    ) {
        this.linkAllFields = this.linkAllFields.bind(this);
        this.getSupplierPid = this.getSupplierPid.bind(this);
        this.createSupplierPidMapping = this.createSupplierPidMapping.bind(this);
        this.getStatus();

        this.edeNumbersDummy.push('dummy');
    }

    public productStates: string[] = [];
    public possibleBrandNames: string[] = [];
    public manufacturerDataSources: ProductDataSource[] = [];
    public newAddedDatasource: ProductDataSource;
    public popupVisible: boolean = false;
    public isLoading: boolean = false;
    public countryCodes: { code: string; name: string; label: string }[] = [];
    public types: string[] = ['Manufacturer', 'Supplier'];

    async ngOnInit(): Promise<void> {
        this.loadManufactures();

        if (this.context.model?.manufacturerName) {
            this.tryLoadPossibleBrandNames();
        }

        const countries = await ViewService.fetchIsoCountyCodes();
        const list = countries?.length ? countries : ViewService.dropDownTerritories;
        this.countryCodes = list.map((c) => ({...c, label: `${c.name} (${c.code})`}));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('model' in changes) {
            const prev = changes['model'].previousValue as Product | undefined;
            const curr = changes['model'].currentValue as Product | undefined;

            const prevName = prev?.manufacturerName ?? '';
            const currName = curr?.manufacturerName ?? '';
            if (currName && currName !== prevName) {
                this.tryLoadPossibleBrandNames();
            }
        }
    }

    private async loadManufactures() {
        this.manufacturerDataSources = await this.dataSourceService.getAll(this.loginService.currentUser.customerId);
        this.manufacturerDataSources = this.manufacturerDataSources.sort((a, b) => a.name.localeCompare(b.name));
    }

    private async tryLoadPossibleBrandNames(prevBrandToPreserve?: string) {
        const name = this.context.model?.manufacturerName?.trim();
        if (!name) {
            this.possibleBrandNames = [];
            return;
        }

        const result = await this.productSercvice.getBrandNameByManufactureName(
            this.loginService.currentUser.customerId,
            name
        );

        const list = Array.isArray(result) ? result : [];
        this.possibleBrandNames = ["", ...list];

        if (prevBrandToPreserve) {
            const exists = list.some(v =>
                (v ?? '').toLocaleLowerCase() === prevBrandToPreserve.toLocaleLowerCase()
            );
            if (!exists) {
                this.context.model.brandName = "";
            } else {
                this.context.model.brandName = prevBrandToPreserve;
            }
        }
    }

    scrapeProduct() {
        this.isLoading = true;
        this.productSercvice.scrapeProduct(this.context.model).subscribe((product: Product) => {
            this.catalogService
                .getProduct(this.context.model.id, this.context.model.customerId, this.catalogService.catalog.id)
                .subscribe(() => {
                    this.context.model = this.catalogService.product;
                    this.isLoading = false;
                });
        });

    }

    onManufacturerCustomItemCreating(e: CustomItemCreatingEvent) {
        const text = (e.text || '').trim();
        if (!text) {
            e.customItem = null;
            return;
        }

        let item = this.manufacturerDataSources.find(
            m => (m.name || '').toLocaleLowerCase() === text.toLocaleLowerCase()
        );

        if (!item) {
            const newItem = ProductDataSource.GetEmptyProductDataSource();
            newItem.id = '';
            newItem.name = text;

            this.manufacturerDataSources = [
                ...this.manufacturerDataSources,
                newItem
            ];

            item = newItem;
        }

        e.customItem = item;

    }

    async onEditSaved($event) {
        this.manufacturerDataSources = await this.dataSourceService.getAll(this.loginService.currentCustomer.id);
    }

    dropDownCfg = {
        toolbarItems: [
            {
                widget: 'dxButton',
                location: 'after',
                options: {
                    icon: 'plus',
                    stylingMode: 'outlined',
                    hint: 'Datenquelle hinzufügen',
                    onClick: () => this.addNewSource()
                }
            }
        ]
    };

    async addNewSource() {
        var newDataSourceAddress = new Address();
        var newDataSourceImporterAddress = new Address();
        this.newAddedDatasource = {
            addressObj: newDataSourceAddress,
            importerAddress: newDataSourceImporterAddress
        } as ProductDataSource;
        this.popupVisible = true;
    }

    getStatus() {
        this.productStateService.getStatus().subscribe((result: ProductState[]) => {
            this.productStates = new Array<string>();
            result.forEach((x) => {
                this.productStates.push(x.name);
            });
        });
    }

    isMaster(): boolean {
        if (!this.context.showLinkButtons) return false;
        if (this.context.model) {
            if (this.context.model.productCount != null && this.context.model.productCount > 0) {
                return true;
            }
        }
        return false;
    }

    isVirtualCatalog(): boolean {
        return this.catalogService?.catalog?.isVirtual;
    }

    updateState(event = null, field?: string, system: string = '-1', element: string = '-1') {
        if (this.context.templateView) {
            // für den template editor erforderlich:
            if (event) {
                event.dField = field;
                event.dSystem = system;
                event.dElement = element;
                event.createTemplateItem = true;
            }

            this.context.valueChanged.emit(event);

            return; // vom Template-Editor getriggert keine neuen Status anlegen!!
        }

        event.value.forEach((val) => {
            if (!this.productStates.find((item) => item == val)) {
                let status = new ProductState();
                status.customerId = this.loginService.currentUser.customerId;
                status.name = val;
                this.productStates.push(val);
                this.productStateService.addProductState(status).subscribe((result: ProductState) => {
                    status = result;
                    this.productStateService.productStates.push(status.name);
                });
            }
        });
        this.context.valueChanged.emit(event);
    }

    async update(event = null, field?: string, system: string = '-1', element: string = '-1') {
        if (!event.event && !event.toggleLinkedFields)
            //happens if value was changed by code and not by ui
            return;

        // für den template editor erforderlich:
        if (event) {
            event.dField = field;
            event.dSystem = system;
            event.dElement = element;
            event.createTemplateItem = true;
        }

        if (field === 'MANUFACTURER_NAME') {
            event.forceReload = true;
            const prevBrand = this.context.model.brandName;
            if (this.context.model.manufacturerName == '') {
                this.context.model.brandName = '';
            }
            await this.tryLoadPossibleBrandNames(prevBrand);
        }
        this.context.valueChanged.emit(event);
    }

    updateFromAutocomplete(event = null, field?: string, system: string = '-1', element: string = '-1') {
        if (!event.selectedItem) return;

        if (event.event == undefined) {
            event.event = new Object(); // für den template editor erforderlich, da sonst keine default-items erstellt werden
        }

        // für den template editor erforderlich:
        if (event) {
            event.dField = field;
            event.dSystem = system;
            event.dElement = element;
            event.createTemplateItem = true;

            event.value = event.selectedItem; // value ist in diesem fall nicht gesetzt, darauf baut aber der template editor
        }

        this.context.valueChanged.emit(event);
    }

    getLanguageFlag(flag) {
        return ViewService.getFlag(flag);
    }

    translateLanguage(code) {
        return TranslationService.translateLanguage(code);
    }

    get hasTranslation(): Boolean {
        return this.context.productTranslation != null;
    }

    public translationUpdate(txtOrg, txtTran) {
        this.context.translationUpdate.emit({txtOrg: txtOrg, txtTran: txtTran});
    }

    get internationalPidType() {
        return ViewService.dropDownInternationalPidType;
    }


    getSupplierPid() {
        lastValueFrom(this.supplierPidMappingService.mapProduct(this.context.model)).then((product: Product) => {
            this.catalogService
                .getProduct(this.context.model.id, this.context.model.customerId, this.catalogService.catalog.id)
                .subscribe(() => {
                    this.context.model = this.catalogService.product;
                });
        }).catch(error => this.systemService.notifyWarning(error?.error?.detail ?? "Produkte konnte nicht gemappt werden"));
    }

    async createSupplierPidMapping() {
        let result = await this.supplierPidMappingService.createSupplerPidMapping(this.context.model);

        for (let error of result.errors) this.systemService.notifyWarning(error);
        for (let info of result.infos) this.systemService.notifyInfo(info);

        this.catalogService
            .getProduct(this.context.model.id, this.context.model.customerId, this.catalogService.catalog.id)
            .subscribe(() => {
                this.context.model = this.catalogService.product;
            });
    }

    linkAllFields() {
        let txtYes = '';
        let txtNo = '';
        let txtMsg = '';
        let txtTitle = '';
        let myDialog: any;

        this.translate.get('Ja').subscribe((text: string) => {
            txtYes = text;
        });
        this.translate.get('Nein').subscribe((text: string) => {
            txtNo = text;
        });
        this.translate
            .get(
                'Sind Sie sicher, dass Sie die Verknüpfungen neu erstellen wollen? Bestehend Verknüpfungen werden überschrieben!'
            )
            .subscribe((text: string) => {
                txtMsg = text;
            });
        this.translate.get('Wirklich neu verknüpfen?').subscribe((text: string) => {
            txtTitle = text;
        });

        myDialog = custom({
            title: txtTitle,
            messageHtml: txtMsg,
            buttons: [
                {
                    text: txtYes,
                    onClick: (e) => {
                        return {buttonText: true};
                    }
                },
                {
                    text: txtNo,
                    onClick: (e) => {
                        return {buttonText: false};
                    }
                }
            ]
        });
        myDialog.show().then((dialogResult) => {
            if (dialogResult.buttonText == true) {
                this.catalogService.linkAllFields(this.context.model).subscribe((product: Product) => {
                    this.catalogService
                        .getProduct(this.context.model.id, this.context.model.customerId, this.catalogService.catalog.id)
                        .subscribe(() => {
                            this.context.model = this.catalogService.product;
                        });
                });
            }
        });
    }

    public readOnlyForLinkedFields(field: string, system: string = '-1', element: string = '-1'): boolean {
        // Wenn dies ein vom Master vererbtes Feld ist, soll es ReadOnly sein:
        if (field != null) {
            var isLinked = this.context.model.isFieldLinked(field, system, element);
            if (isLinked && this.context.model.isChild != null && this.context.model.isChild) {
                // Für einen Master darf es nicht ReadOnly werden!!
                return true;
            }
        }

        //return this.readOnly(productId);

        return false;
    }

    public showClearButton(field: string): boolean {
        return !this.readOnlyForLinkedFields(field) && !this.context.templateView;
    }

    public hasMasterOrChildOrIsTranslated(): boolean {
        // Im Übersetzungsmodus nicht anzeigen
        if (this.hasTranslation) {
            return false;
        }

        return this.context.model.hasMasterOrChild();
    }

    public isFieldLinked(field: string, system: string = '-1', element: string = '-1'): boolean {
        return this.context.model.isFieldLinked(field, system, element);
    }

    public toggleLinkedField(field: string, system: string = '-1', element: string = '-1', event = null) {
        var changed = this.context.model.toggleLinkedField(field, system, element);
        if (!changed) {
            return;
        }

        var isNowLinked = this.isFieldLinked(field, system, element);
        event.target.className = this.context.model.getClassForLinkedField(isNowLinked);

        if (this.context.model.isChild && isNowLinked) {
            event.forceReload = true;
        }

        if (field == 'DESCRIPTION_SHORT' || field == 'SUPPLIER_PID') {
            // Etwas schmutzig, aber sonst können wir den Refresh am Tree nicht antriggern.
            event.forceTreeRefresh = true;
        }

        // SAVE
        this.update(event);
    }

    public getInitialClassForLinkedField(field: string, system: string = '-1', element: string = '-1'): string {
        var isNowLinked = this.isFieldLinked(field, system, element);
        return this.context.model.getClassForLinkedField(isNowLinked);
    }

    canView(name: string): boolean {
        return this.userManagement.canView(name);
    }

    readOnly(name: string): boolean {
        return this.isVirtualCatalog() || !this.userManagement.canEdit(name);
    }
}
